import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	ViewChild
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { ITGlueExport } from 'DiscoveryEngine.TS/Export';
import { ITGlueExportConfigComponent } from '../itglue-export-config/itglue-export-config.component';

@Component({
	selector: 'sched-disc-config-itglue',
	templateUrl: './sched-disc-config-itglue.component.html',
	styleUrls: ['./sched-disc-config-itglue.component.scss']
})
export class SchedDiscConfigITGlueComponent extends SchedDiscConfigComponentBase {

	@ViewChild(ITGlueExportConfigComponent, { static: true })
	private ITGlueExportComp: ITGlueExportConfigComponent;

	private static NullITGlueExport = new ITGlueExport();

	public get ITGlueExport(): ITGlueExport {
		if (this.Discovery)
			return this.Discovery.ITGlueExport;
		else
			return SchedDiscConfigITGlueComponent.NullITGlueExport;
	}

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
	}

	protected BuildForm(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
	}

	public get tempChanges(): boolean {
		return this.ITGlueExportComp.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.ITGlueExportComp.tempChangesValid;
	}

	public applyTempChanges(): void {
		this.ITGlueExportComp.applyTempChanges();
		this.onApplyTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return this.ITGlueExportComp.invalidTempChanges;
	}

	public discardTempChanges(): void {
		this.ITGlueExportComp.discardTempChanges();
	}

}
